/*
|--------------------------------------------------------------------------
| Views: Common
|--------------------------------------------------------------------------
*/

/**
 * Salesforce PI feed preparser
 * @namespace
 * @param {object} bucket - bucket object
 */
__gh__webApp.feedPreparsers.salesforcePI = function(bucket){		
	var commonPreparser = __gh__webApp.feedPreparsers.common,
		originalItems 	= bucket.items[0].items,
		items		  	= [];
		
		for(var i=0; i < originalItems.length;i++){
			item 			= originalItems[i];
			items.push(commonPreparser.getItem({
				"title" 		: item.content_title,
				"link"			: item.link,
				"category"		: item.category,
				"date"			: {
					"pubDateObject"	: new Date(item.publication_date),
					"utcFormat"	: true,
					"hideTime"	: true
				},
				"image"		: {
					"link": item.content_image_link,
				}
			}));

		}
		bucket.items = {"main":items};
	
	return bucket;
};